import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';
import { HomeComponent } from './home.component';
import { Layouts } from '../app.component'

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: { layout: Layouts.Main }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
